import baseTranslations from './base.json';
import {translateWithTranslations} from '../../helpers/translationHelper';
import {deepMap} from '../../helpers/deepMap';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

// dayjs.months()/monthsShort() below need the localeData plugin. The main app's own
// dateTimeHelper.ts also extends dayjs with it, but that file pulls in a Pinia store that
// isn't safe to import from contexts (like the Outlook add-in) that reuse this file standalone.
// dayjs.extend() is idempotent, so registering it here too is a harmless no-op there.
dayjs.extend(localeData);

const importMap = import.meta.glob('./**.json');

export async function getPrimeVueLocale(locale, translations) {
    const translated = deepMap(baseTranslations, val => {
        const translationString = translateWithTranslations(translations, val);
        return adjustPlaceholderSyntax(translationString);
    });

    const response = await importMap[`./${locale}.json`]();

    return {...getLocalizedCalendarTranslations(), ...translated, ...response};
}

const parameterRegEx = /%(.+?)%/g;

/**
 * Replaces parameter occurrences in the format '%parameter%'
 * with the required PrimeVue format '{parameter}'
 * @param {String} translationString
 */
function adjustPlaceholderSyntax(translationString) {
    if (typeof translationString !== 'string') {
        return translationString;
    }

    return translationString.replaceAll(parameterRegEx, (_, parameter) => {
        return `{${parameter}}`;
    });
}

function getLocalizedCalendarTranslations() {
    return {
        monthNames: dayjs.months(),
        monthNamesShort: dayjs.monthsShort(),
    };
}
